var View = function View(title, templateName, data, containerCss, bodyCss, afterRender) {
    this.title = title;
    this.templateName = templateName;
    this.data = ko.observable(data);
    this.containerCss  = containerCss;
    this.bodyCss = bodyCss;
    this.afterRender = afterRender;
};


function LandingViewModel(mvm, arguments) {
    var self = this;

    LoginViewModel.apply(this, arguments);

    self.showBoardInfo = ko.observable(false);
    self.showWalls = ko.observable(false);
    self.isContentBoard = ko.computed(function () { return true} );
    self.isOwner = ko.observable(false);
    self.hasFreePlan = ko.observable(true);

    self.selectPlanTemplate = ko.observable("selectPlanT");
    self.selectPlan = new View("Select Plan", self.selectPlanTemplate, new SelectPlanViewModel(self, self.closesModal));
    self.enterShortCode = null;

    self.goToSelectPlan = function (vm, e) {
        self.selectPlan.data().getPlansInfo(function () {
            self.smallModalView(self.selectPlan);
        });

        if (e) {
            return false;
        }
    };

    self.goToSelectPlanFromPost = function (vm, e) {
        self.selectPlan.data().nextUrl("reload");
        self.selectPlan.data().getPlansInfo(function () {
            self.smallModalView(self.selectPlan);
        });

        if (e) {
            return false;
        }
    };

    self.goBackToSelectPlan = function () {
        self.selectPlanTemplate("selectPlanT");
        self.selectPlan.data().clearSelection();
    };

    self.goToConfirmPlan = function () {
        self.smallModalView(self.confirmPlan);
    }

    self.goBackToConfirmPlan = function () {
        self.selectPlanTemplate("confirmPlanT");
    };

    self.goToSendFeedback = function () {
        self.smallModalView(self.sendFeedback);
    };

    self.goToEnterShortCode = function () {
        if (!self.enterShortCode) {
            self.enterShortCode = new View("Enter ShortCode", "enterShortCodeT", new EnterShortCodeViewModel(self));
        }
        self.smallModalView(self.enterShortCode);
    };

    self.loginView = new View("Login", "loginT", self);

    self.goToLogin = function (vm, e, nextUrl) {
        if (nextUrl) {
            self.loginView.data().nextUrl(nextUrl);
        }
        self.smallModalView(self.loginView);

        if (e) {
            return false;
        }
    };

    self.goToLoginFromPost = function (vm, e, nextUrl) {
        self.loginView.data().nextUrl("reload");
        self.smallModalView(self.loginView);

        if (e) {
            return false;
        }
    };


    self.resetPasswordRequestView = new View("Reset Password", "resetPasswordRequestT", self);

    self.goToResetPassword = function () {
        self.smallModalView(self.resetPasswordRequestView);
    };

    // Display Menu
    self.toggleHeaderMenu = function (menu, event) {

        var $menus = $(".cbp-spmenu-s3");
        classie.toggle(event.target, "active");

        $menus.each(function (index, item) {
            classie.toggle(item, "cbp-spmenu-open");
        });

    };

    self.closeAndGoToPublic = function (menu, event) {
        self.toggleHeaderMenu(menu, event);
        window.location.href = "/#!wall/public";
    };

    self.closeAndGoToWall = function (menu, event) {
        self.toggleHeaderMenu(menu, event);
        window.location.href = "/#!wall/owned";
    }

     self.closeAndGoToFeatured = function (menu, event) {
        self.toggleHeaderMenu(menu, event);
        window.location.href = "/#!featuredBoards";
    };


    self.setModalToggle = function (selector) {
        if (!$(selector).hasClass('in')) {
            $(selector).modal('show');
            //   Make the [esc] key close the modal. This also allows Android "Back" buttons to close it. But with the selector used, it only works if the modal has focus.
            $(selector).off('keydown');
            $(selector).on('keydown', function (event) {
                if (event.keyCode == 27) {
                    event.preventDefault();
                    $(selector).modal('hide');
                }
            });
        }
    };

    self.modalTemplateName = ko.observable();
    self.modalData = ko.observable();
    self.mediumModalView = ko.observable();
    self.mediumModalView.subscribe(function (newValue) {
        if (newValue) {
            self.setModalToggle("#mediumModal");
        }
    });
    self.smallModalView = ko.observable();
    self.smallModalView.subscribe(function (newValue) {
        if (newValue) {
            self.setModalToggle("#smallModal");
        }
    });
    self.closeModal = function () {
        $("#mediumModal").modal('hide');
        $("#smallModal").modal('hide');
    }
    self.sendFeedback = new View("Send Feedback", "sendFeedbackT", new SendFeedbackViewModel(self, self.closeModal));

}


function HeaderMenuViewModel(mvm, arguments) {
    var self = this;
}

function AuthViewModel(mvm, arguments) {
    var self = this;

    self.email = ko.observable();
    self.password = ko.observable();
    self.password2 = ko.observable();
    self.token = ko.observable();
    self.message = ko.observable();
    self.success = ko.observable();
    self.successMessage = ko.observable('');
    self.nextUrl = ko.observable(queryString["next"]);
    //Show close button on modal.
    self.showClose = ko.observable();

    self.isLoggedIn = ko.observable(false);
    self.goToNextPage = function () {

        if (self.nextUrl() === "reload") {
            window.location.reload();
            return;
        }

        if (queryString["next"]) {
            window.top.location.href = queryString["next"];
        } else {
            window.top.location.href ="/";
        }
    };

    self.facebookLogin = function (vm, e, callback) {

        FB.login(function(response) {
            if (response.authResponse) {
                // FB has accepted login. Now log the user in to Cobbl.
                $.ajax({
                    url: "/facebook-login/",
                    type: "GET",
                    success:function(result) {
                        self.error(!result.success);
                        if (result.success) {
                            self.isLoggedIn(true);
                            self.username(result.username)
                            if (callback) {
                                callback();
                            } else {
                                self.goToNextPage();
                            }
                            self.name(undefined);
                        } else {
                            self.errorMessage2(result.message);
                        }
                    },
                    error: function(xhr, ajaxOptions, thrownError) {
                        console.log(xhr);
                        console.log(xhr.responseText);
                    }
                });

            } else {
                console.log('User cancelled login or did not fully authorize.');
            }
        },{scope: 'public_profile, email, user_photos'});

    };

}

function RegisterViewModel(mvm) {
    AuthViewModel.apply(this, arguments);
    var self = this;

    self.title = ko.observable("Sign up :)");
    //Show close button on modal.
    self.showClose = ko.observable();
    self.name = ko.observable();
    self.connect = ko.observable(false);
    self.emailError = ko.observable(false);
    self.emailErrorMessage = ko.observable();
    self.email.subscribe(function (newValue) {
        if (self.error() && newValue !== "" && typeof newValue !== "undefined") {
            self.error(false);
        }
    });
    self.passwordError = ko.observable(false);
    self.passwordErrorMessage = ko.observable();
    self.password.subscribe(function (newValue) {
        if (self.error() && newValue !== "" && typeof newValue !== "undefined") {
            self.error(false);
        }
    });

    self.error = ko.observable(false);
    self.errorMessage = ko.observable();
    self.errorMessage2 = ko.observable();
    self.errorMessage2.subscribe(function (value) {
        console.log(value);
    });

    self.username = ko.observable();

    //these mock mainViewModel
    if(!mvm) {
        mvm = self;
    }
    self.loadingMessage = ko.observable();
    self.addMessage = function(message, severity) {
        self.message(message);
    };

    //operations
    self.register = function(callback) {
        self.emailError(false);
        self.emailErrorMessage(undefined);
        self.passwordError(false);
        self.passwordErrorMessage(undefined);
        self.error(false);
        self.errorMessage(undefined);
        if(!self.email()) {
            self.emailError(true);
            self.emailErrorMessage("An email address is required");
            return;
        }
        if(!self.password()) {
            self.passwordError(true);
            self.passwordErrorMessage("Please choose a password");
            return;
        }
        if (!self.password() === self.password2()) {
            self.error(true);
            self.errorMessage("Passwords do not match");
        }
        // if(!self.name()) {
        //     self.message("Please choose a username");
        //     return;
        // }

        $.ajax(
            {
                url: "/create/",
                type: "POST",
                data: {
                    //name: self.name(),
                    email: self.email(),
                    password: self.password(),
                    token: self.token,
                    connect: self.connect()
                },
                success:function(result) {
                    //check if valid user, if valid user, take user to board screen.
                    //set current user in main view model so we know they're logged in.
                    self.error(!result.success);
                    if (result.success) {
                        self.isLoggedIn(true);
                        self.username(result.username)
                        if (callback) {
                            callback();
                        } else {
                            self.goToNextPage();
                        }
                        self.name(undefined);
                    } else {
                        self.errorMessage(result.message);
                    }
                }
            }
        );

        return true;
    };

    self.facebookRegister = function (callback) {

        FB.login(function(response) {
            if (response.authResponse) {
                // FB has accepted login. Now register to Cobbl.
                $.ajax({
                    url: "/facebook-register/",
                    type: "GET",
                    success:function(result) {
                        self.error(!result.success);
                        if (result.success) {
                            self.isLoggedIn(true);
                            self.username(result.username)
                            self.email(result.email)
                            if (callback) {
                                callback();
                            } else {
                                self.goToNextPage();
                            }
                            self.name(undefined);
                        } else {
                            self.errorMessage2(result.message);
                        }
                    },
                    error: function(xhr, ajaxOptions, thrownError) {
                        console.log(xhr);
                        console.log(xhr.responseText);
                        self.error(True);
                        self.errorMessage2(xhr.responseText);
                    }
                });
            } else {
                self.error(True);
                self.errorMessage2("User cancelled login or did not fully authorize.");
            }
        }, {scope: 'public_profile, email, user_photos'});

        return true;
    };

    self.postRenderLogic = function() { };

    self.saveUsername = function (callback) {
        $.post("/updateProfile/",
            {"username": self.username()},
            function (d) {
                if (d.success) {
                    //parentViewModel.addMessage("updated", "success");
                    self.errorMessage("");
                    self.error(false);
                    if (callback) {
                        callback();
                    }
                } else {
                    self.errorMessage(d.message);
                    self.error(true);
                }
             }
        );
    };

    self.finishLogin = function () {
        self.saveUsername(self.goToNextPage);
        return false;
    };
}

function LoginViewModel(loginVisible) {
    RegisterViewModel.apply(this, arguments);

    var self = this;

    self.submitting = ko.observable();
	self.loginVisible = ko.observable(loginVisible);

    self.submitText = ko.computed(function(){

        if (self.loginVisible()) {
            if (self.submitting()) {
                return "checking Login..."
            }
            return "Login"
        } else {
            if (self.submitting()) {
                return "Resetting password..";
            }
            return "Reset password";
        }

    });

    self.showResetPassword = function(){
        self.loginVisible(false);
    };
    //operations

    self.email.subscribe(function (newValue) {
        self.error(false);
    });

    self.login = function() {

        self.submitting(true);
        $.ajax({url: "/login", type: "POST",data: { email: self.email(), password: self.password()},
            success: function (result) {
                self.error(!result.success);
                if (result.success) {
                    var nextUrl = self.nextUrl();
                    if (nextUrl != null) {
                        if (nextUrl === "reload") {
                            window.location.reload();
                        } else {
                            if (nextUrl.indexOf("!") == 0) {
                                var location = window.location.pathname + "#" + nextUrl;
                                window.location.href = location;
                            } else {
                                window.location.href = self.nextUrl();
                            }
                        }
                    } else {
                        window.location.href = "/";
                    }
				} else {
                    self.errorMessage(result.message);
                    self.password(undefined);
					self.submitting(undefined);
                }
            }
        });

    };

    self.resetPasswordRequest = function() {
        $.ajax({
            url: "/resetPasswordRequest",
            type:"POST",
            data: { email: self.email() },
            success: function(result) {
                //send confirmation saying password reset has been sent.
                self.message(result.message);
                self.success(result.success);
            }
        });
    };

}

function ResetPasswordViewModel(parentViewModel) {

    var self = this;
    AuthViewModel.apply(this, arguments);
    self.submitText = ko.observable("Reset Password");
    self.confirmPassword = ko.observable();
    self.successMessage = ko.observable('');

    self.canContinue = ko.computed(function() {

        if(!self.password()) {
            return false;
        }

        if(self.password() && self.password().length < 5) {
            self.message({message:"Password too short", css:"alert-danger"});
            return false;
        }

        var passwordsDoNotMatch = self.confirmPassword()!=self.password();
        if(passwordsDoNotMatch) {
            self.message({message:"The passwords do not match", css:"alert-danger"});
            return false;
        } else {
             self.message(undefined);
            return true;
        }
    });
    //operations
    self.resetPassword = function() {
        self.submitText("resetting...");

        $.ajax({
            url: window.location,
            type: "POST",
            data: { password: self.password() },
            success: function (result) {
                if (result.success) {
                    window.location = '/login';
                } else {
                    self.message({ message: result.message, css: "alert-danger" });
                }
            }
        });
    };

}

function SwitchLayoutViewModel(item) {

    var self = this;

    self.listTemplateName = item + 'ViewListT';
    self.cardsTemplateName = item + 'ViewCardsT';
    self.templateName = ko.observable(self.cardsTemplateName);

    var rightPanelEnabled = false;
    if (self.templateName === self.listTemplateName) {
        rightPanelEnabled = true;
    }
    self.rightPanelVisible = ko.observable(rightPanelEnabled);

    self.cardsViewOn = ko.computed(function () {
        return self.templateName() == self.cardsTemplateName;
    });

    self.listViewOn = ko.computed(function () {
        return self.templateName() == self.listTemplateName;
    });

    self.setCardsViewType = function () {
        self.templateName(self.cardsTemplateName);
        jqueryRelayoutIsotope();
    };

    self.setListViewType = function () {
        self.templateName(self.listTemplateName);
        self.rightPanelVisible(true);

        var tableSelector = '#' + item + '-view-table';
        $table = $(tableSelector);
        $clone = $(tableSelector + '-clone');
        $clone.addClass('tableCloned');
        $clone.css('background-color', '#121315');
        $clone.find('tbody').remove();

        $originalThs = $table.find('thead th');
        $fixedThs = $clone.find('thead th');

        $fixedThs.each(function(position) {
            var width = $($originalThs[position]).outerWidth();
            $($fixedThs[position]).css("width", width + "px") ;
        });

        $clone.width($table.width());
        $table.find('thead').css('visibility', 'hidden');
        $clone.show();
    };


    self.toggleViewType = function () {

        if (self.templateName() === self.listTemplateName) {
            self.setCardsViewType();
        } else {
            self.setListViewType();
        }
    };

    self.toggleRightPanel = function () {
        self.rightPanelVisible(!self.rightPanelVisible());
        if (self.rightPanelVisible()) {
            $('#' + item + '-view-table-clone').show();
            $('#' + item + '-view-table thead').css('visibility', 'hidden');
        }

        $table = $('#' + item + '-view-table');
        $originalThs = $table.find('thead th');
        $clone = $('#' + item + '-view-table-clone');
        $fixedThs = $clone.find('thead th');

        $fixedThs.each(function(position) {
            var width = $($originalThs[position]).width();
            $($fixedThs[position]).width(width) ;
        });
        $clone.width($table.width());
    };

    $( window ).resize(function() {
        var tableSelector = '#' + item + '-view-table';
            $table = $(tableSelector);
        $clone = $(tableSelector + '-clone');

        $originalThs = $table.find('thead th');
        $fixedThs = $clone.find('thead th');

        $fixedThs.each(function(position) {
            var width = $($originalThs[position]).outerWidth();
            $($fixedThs[position]).css("width", width + "px") ;
        });

        $clone.width($table.width());
    });
};

function EnterShortCodeViewModel(parentViewModel) {

    self.shortCode = ko.observable();
    self.shortCodeError = ko.observable();

    self.goToBoardByShortCode = function (data) {
        if (data.success) {
            $("#smallModal").modal("hide");
            window.location.href = "/#!board/" + self.shortCode();
        } else {
            self.shortCodeError(data.message);
        }
    };

    self.goToBoard = function (data, event) {
        event.preventDefault();
        event.stopPropagation();

        if (typeof BoardViewModel === "undefined") {
            $("#smallModal").modal("hide");
            window.location.href = "/#!board/" + self.shortCode();
        } else {
            var board = new BoardViewModel(parentViewModel);
            board.getContent(self.shortCode(), null, false, null, undefined, undefined, 'init', null, self.goToBoardByShortCode);
        }
        return false;
    };

};

function SendFeedbackViewModel(parentViewModel, callback) {
    var self = this;

    self.email = ko.observable("");
    self.name = ko.observable("");
    self.message = ko.observable("");

    //operations
    self.sendFeedback = function() {
        var data = {
            email: self.email(),
            name: self.name(),
            message: self.message(),
        };
        $.post("/feedback", data, function (d) {
            if (d.success == false) {
                self.addMessage(d.message, "error");
            } else {
                self.addMessage("Feedback sent", "success");
                self.message('');
                if (callback) {
                    callback();
                }
                $("#smallModal").modal('hide');
            }
        });
    };

    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-bottom-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "3000",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    }
    self.addMessage = function (message, severity, time) {

        if (time) {
            toastr.options['showDuration'] = time*1000;
        }
        toastr[severity](message)
    };

}


function SubscriptionViewModel(parentViewModel, section) {
    var self = this;

    section  = section || 'profile';
    self.section = ko.observable(section);

    self.getTemplateName = ko.computed(function  () {
        var templateName = 'Account' + self.section().charAt(0).toUpperCase() + self.section().slice(1) + 'ViewT';
        console.log(templateName);
        return templateName;
    });
    self.accountData = ko.observable();

    //Navigation
    self.switchTabToProfile  = function () {
        self.section('profile');
    };

    self.switchTabToEmailPreferences  = function () {
        self.section('emailPreferences');
    };

    self.switchTabToPassword  = function () {
        self.section('password');
    };

    self.switchTabToData = function () {
        self.section("data");
    };

    self.switchTabToBilling  = function () {
        self.section("billing");
    };

    self.switchTabToSubscription  = function () {
        self.section('subscription');
    };

    self.setAccountData = function (data, callback) {
        self.planName(data.planName);
        self.planAmount(data.planAmount);
        self.planInterval(data.planInterval);
        self.cancelAtPeriodEnd(data.cancelAtPeriodEnd);
        self.currentPeriodEnd(new Date(data.currentPeriodEnd * 1000));
        self.storageLimit(data.storageLimit);
        if (callback) {
            callback();
        }
    };

    self.loadAccountData = function  (callback) {
        var currentUser = parentViewModel.currentUser();
        self.cardErrorMessage('');
        currentUser.loadAccountData(function (data) {
            self.setAccountData(data, callback);
        });
    };

    //Stripe elements
    // todo inspect and remove
    // Create a Stripe client.
    self.stripe = Stripe('pk_test_waIEvCqt0UpyQq4xJGd9xjlP');
    // Create an instance of Elements.
    self.elements = self.stripe.elements();
    self.premiumPlan = "pro_monthly";
    //Style to match bootstrap
    var style = {
            base: {
                'lineHeight': '1.4',
                'fontSize': '13px',
                'color': '#495057',
                'fontFamily': 'Helvetica Neue",Arial,sans-serif'
            }
        };
    // Create an instance of the card Element.
    self.cardNumberElement = self.elements.create('cardNumber', {
        placeholder: 'Card Number',
        style: style,
    });
    self.cardExpiryElement = self.elements.create('cardExpiry', {
        style: style,
    });
    self.cardCvcElement = self.elements.create('cardCvc',{
        style: style,
    });
    self.cardPostCodeElement = self.elements.create('postalCode', {
        placeholder: 'Postal Code',
        style: style,
    });

    self.cardNumberId = ko.observable();
    self.cardExpiryId = ko.observable();
    self.cardCvcId = ko.observable();
    self.cardPostCodeId = ko.observable();

    self.mountCardOnCheckout = function () {
        self.unmountCard();
        self.cardNumberId("#card-number-element");
        self.cardExpiryId("#card-expiry-element");
        self.cardCvcId("#card-cvc-element");
        self.cardPostCodeId("#card-post-code-element");
        self.mountCard();
    }


    self.mountCardOnBilling = function () {
        self.unmountCard();
        self.cardNumberId("#card-number-element-billing");
        self.cardExpiryId("#card-expiry-element-billing");
        self.cardCvcId("#card-cvc-element-billing");
        self.cardPostCodeId("#card-post-code-element-billing");
        self.mountCard();
    }

    self.unmountCard = function () {
        self.cardNumberElement.unmount(self.cardNumberId());
        self.cardExpiryElement.unmount(self.cardExpiryId());
        self.cardCvcElement.unmount(self.cardCvcId());
        self.cardPostCodeElement.unmount(self.cardPostCodeId());
    }

    self.mountCard = function () {
        self.cardNumberElement.mount(self.cardNumberId());
        self.cardExpiryElement.mount(self.cardExpiryId());
        self.cardCvcElement.mount(self.cardCvcId());
        self.cardPostCodeElement.mount(self.cardPostCodeId());
    }
    // Payment sources
    self.sources = ko.observableArray();
    self.defaultSource = ko.observable();
    self.cardErrorMessage = ko.observable();
    self.selectedSourceForDefault = ko.observable();
    self.paymentInProcess = ko.observable(false);
    self.showSourceInfo = ko.observable(true);
    self.showSourceList = ko.observable(false);
    self.showSourcesList = ko.computed( function () {
        return self.sources.length > 0;
    });
    self.toggleShowSourcesTable = function () {
        self.showSourcesTable(!self.showSourcesTable());
    }
    self.cardName = ko.observable();
    self.cardLastName = ko.observable();
    self.cardAddress = ko.observable();
    self.cardCity = ko.observable();
    self.cardCountry = ko.observable();
    self.cardSetAsDefault = ko.observable(false);


    self.showSourceInfo = ko.observable(true);
    self.showSourceList = ko.observable(false);
    self.showSourcesList = ko.computed( function () {
        return self.sources.length > 0;
    });

    self.showCardForm = ko.observable(true);

    self.updateDefaultSource = function () {
        if (self.selectedSourceForDefault() != self.defaultSource()) {
            $.ajax({
                url: "/updateDefaultSource/",
                type: "POST",
                data: {
                      source_id: self.selectedSourceForDefault(),
                },
                success: function(result) {
                    self.loadAccountData();
                    if (result.success) {
                        parentViewModel.addMessage(result.message, "success");
                    } else {
                        parentViewModel.addMessage(result.message, "error");
                    }
                }
            });
        }
    };

    self.addCard = function (event, callback) {
        var token;
        self.stripe.createToken(self.cardNumberElement).then(function(result) {
            // Handle result.error or result.token
            token = result.token;
            if (token) {
                $.ajax({
                    url: "/addCreditCard/",
                    type: "POST",
                    data: {
                        card_token: token.id,
                        name: self.cardName(),
                        last_name: self.cardLastName(),
                        set_as_default: "True",
                    },
                    success: function(result) {

                        if (result.success) {
                            callback();
                        } else {

                        }
                    }
                });
            } else {
                self.cardErrorMessage(result.message);
            }
        });
    };

    self.addCardAndUpgrade = function (event) {
        var token;
        self.selectedPlan(self.premiumPlan);
        self.stripe.createToken(self.cardNumberElement).then(function(result) {
            token = result.token;
            if (token) {
                var set_as_default = "";
                if (self.cardSetAsDefault()) {
                    set_as_default = "True";
                }
                self.paymentInProcess(true);
                $.ajax({
                    url: "/addCreditCardAndUpgrade/",
                    type: "POST",
                    data: {
                          card_token: token.id,
                          name: self.cardName(),
                          last_name: self.cardLastName(),
                          address: self.cardAddress(),
                          city: self.cardCity(),
                          country: self.cardCountry(),
                          set_as_default: set_as_default,
                          plan_id: self.selectedPlan(),
                    },
                    success: function(result) {
                        self.loadAccountData();
                        self.paymentInProcess(false);
                        if (result.success) {
                            parentViewModel.addMessage(result.message, "success");
                            parentViewModel.goToUpgradeConfirmed();
                            return result.source_id;
                        } else {
                            parentViewModel.addMessage(result.message, "error");
                        }
                    }
                });
            } else {
                self.cardErrorMessage(result.error.message);
            }
        });
    };

    //Plans and subscriptions
    self.plan = ko.observable();
    self.planName = ko.observable();
    self.planAmount = ko.observable();
    self.planInterval = ko.observable();
    self.planEmail = ko.observable();
    self.subscription = ko.observable();
    self.cancelAtPeriodEnd = ko.observable();
    self.currentPeriodEnd = ko.observable();
    self.selectedPlan = ko.observable();
    self.storageLimit = ko.observable();
    self.selectedSourceForPayment = ko.observable();

    self.changeSubscriptionPlan = function (event) {
        self.paymentInProcess(true);
        $.ajax({
            url: "/changeSubscriptionPlan/",
            type: "POST",
            data: {
                  plan_id: self.selectedPlan(),
                  source_id: self.selectedSourceForPayment(),
            },
            success: function(result) {
                self.loadAccountData();
                self.paymentInProcess(false);
                if (result.success) {
                    parentViewModel.addMessage(result.message, "success");

                } else {
                    parentViewModel.addMessage(result.message, "error");
                }
            }
        });
    };

    self.cancelSubscription = function () {
        $.ajax({
            url: "/cancelAtPeriodEnd/",
            type: "POST",
            data: {},
            success: function(result) {
                self.loadAccountData();
                if (result.success) {
                    parentViewModel.addMessage(result.message, "success");
                    $("#mediumModal").modal("hide");
                } else {
                    parentViewModel.addMessage(result.message, "error");
                }
            }
        });
    };

    self.renewSubscription = function () {
        $.ajax({
            url: "/renewAtPeriodEnd/",
            type: "POST",
            data: {},
            success: function(result) {
                self.loadAccountData();
                if (result.success) {
                    parentViewModel.addMessage(result.message, "success");
                } else {
                    parentViewModel.addMessage(result.message, "error");
                }
            }
        });
    };

    self.goToUpgradeConfirmed = function () {
        parentViewModel.goToUpgradeConfirmed();
    };

    self.goToConfirmDeleteAccount = function () {
        parentViewModel.goToConfirmDeleteAccount();
    };

}


function SelectPlanViewModel(parentViewModel, callback) {
    RegisterViewModel.apply(this, arguments)
    SubscriptionViewModel.apply(this, arguments);
    var self = this;

    // TODO: move plan information to the backend (proof of concept only)
    self.plans = ko.observable();
    self.planFeatures = [
        "Create boards",
        "Move/Copy pictures to other boards",
        "Share boards / share images",
        "Guest viewing",
        "Any user can upload",
        "Set user privileges",
        "Integrate with mobile",
        "Add comments",
        "Notifications of new posts",
        "Auto-flag for inappropriate content",
        "Personal and auto tags",
        "Website and community support",
        "Grid and list view",
        "Download images",
        "Restrict comments and downloads",
        "Slide show controls",
        "Direct email support",
        "User dashboard",
        "Analytics"
    ];

    self.freePlanInfo = {
        name: "Free",
        amount: ko.observable(0.00),
        description: "Excellent features for free",
        secondaryDescription: "",
        selectPlan: "self.goToFreePlan()",
        expanded: ko.observable(false),
        recommended: false,
        compare: true,
        isSubscribed: ko.computed(function () {
            return self.planName() == "Free";
        }),
        storageLimit: 10,
        featuresIn: 12,
        featuresPlus: 12,
        paid: false,
        visible: true,
        freeWithThisDeal: false
    };

    self.teamPlanInfo = {
        name: "Team",
        amount: null,
        description: "For organizations with many users. Bulk add team members, retain control of all organization images and manage user and guest access.",
        secondaryDescription: "(August 2021)",
        selectPlan: null,
        expanded: ko.observable(false),
        recommended: false,
        compare: false,
        isSubscribed: ko.computed(function () {
            return self.planName() == "Team";
        }),
        featuresIn: 12,
        featuresPlus: 15,
        storageLimit: 0,
        paid: true,
        visible: true,
        freeWithThisDeal: false
    };
    self.standardPlanInfo = {};
    self.premiumPlanInfo = {};

    self.setPlans = function (plans) {
        for (var key in plans) {
            var plan = plans[key];
            if (plan["ordering"] == 1) {
                self.standardPlanInfo = {
                    prices: plan["prices"]
                }
                self.standardPlanInfo = {
                    name: plan["name"],
                    prices: plan["prices"],
                    amount: ko.computed(function () {
                        var amount;
                        ko.utils.arrayForEach(self.standardPlanInfo.prices, function (item) {
                            if (item.interval == self.interval()) {
                                amount = item.amount;
                            }
                        });

                        return amount.toFixed(2);
                    }),
                    description: "For users with thousands of images. Send email invites, dashboard view, family share, with 10GB and more!",
                    secondaryDescription: "(May 2021)",
                    selectPlan: "self.goToStandardPlan()",
                    expanded: ko.observable(false),
                    recommended: false,
                    compare: true,
                    isSubscribed: ko.computed(function () {
                        return self.planName() == plan["name"];
                    }),
                    storageLimit: 15,
                    featuresIn: 12,
                    featuresPlus: 17,
                    paid: true,
                    visible: true,
                    freeWithThisDeal: true
                };
            }
            if (plan["ordering"] == 2) {
                self.premiumPlanInfo = {
                    prices: plan["prices"]
                }
                self.premiumPlanInfo = {
                    name: plan["name"],
                    prices: plan["prices"],
                    amount: ko.computed(function () {
                        var amount;
                        ko.utils.arrayForEach(self.premiumPlanInfo.prices, function (item) {
                            if (item.interval == self.interval()) {
                                amount = item.amount;
                            }
                        });
                        return amount.toFixed(2);
                    }),
                    description: "Basica plan plus meta data display, image analytics, custom sort images, embed boards, 15GB and more!",
                    secondaryDescription: "(June 2021)",
                    selectPlan: "self.goToPremiumPlan()",
                    expanded: ko.observable(false),
                    recommended: false,
                    compare: true,
                    isSubscribed: ko.computed(function () {
                        return self.planName() == plan["name"];
                    }),
                    featuresIn: 17,
                    featuresPlus: 19,
                    storageLimit: 100,
                    paid: true,
                    visible: true,
                    freeWithThisDeal: true
                };
            }
        }

        if (self.planName()) {
            var selectedPlanString = "self." + self.planName().toLowerCase() + "PlanInfo";
            self.selectedPlanInfo(eval(selectedPlanString));
        }

    };
    self.getPlansInfo = function (callback) {
        $.ajax({
            url: "/getPlansInfo/",
            type:"GET",
            success: function(result) {
                if (result.success) {
                    var plans = result.data;
                    self.setPlans(plans);
                    if (callback) {
                        callback();
                    }
                } else {

                }
            }
        });

    };

    self.interval = ko.observable("month");
    self.yearlyToggle = ko.observable(false);
    self.yearly = ko.observable(false);
    self.toggleYearly = function () {
        if (self.yearly()) {
            self.interval("year");
        } else {
            self.interval("month");
        }

        return true;
    };

    self.selectPlanHandler = function (data) {
       eval(data.selectPlan);
    }

    self.selectedPlanInfo = ko.observable();
    self.getSelectedPrice = function () {
        var selected = self.selectedPlanInfo();
        if (selected) {
            var price;
            ko.utils.arrayForEach(selected.prices, function (item) {
                if (item.interval == self.interval()) {
                    price = item.id;
                }
            });

            return price;
        }
    };
    self.getSelectedAmount = ko.computed(function () {
        var selected = self.selectedPlanInfo();
        if (selected) {
            if (selected.amount()) {
                return selected.amount();
            }
        }
    });
    self.getSelectedPlanName = ko.computed(function () {
        var selected = self.selectedPlanInfo();
        if (selected) {
            return selected.name + " (" + self.interval() + ")";
        }
    });
    self.isSelectedPlanPaid = ko.computed(function () {
        var selected = self.selectedPlanInfo();
        if (selected) {
            return selected.paid;
        }
    });

    self.clearSelection = function () {
        self.selectedPlanInfo(null);
    };

    self.togglePlanFeatures = function (data) {
        data.expanded(!data.expanded());
        return true;
    };

    self.expanded = ko.observable(false);

    self.goToFreePlan = function () {
        self.selectedPlanInfo(self.freePlanInfo);
        parentViewModel.selectPlanTemplate("confirmPlanT");
    };

    self.goToStandardPlan = function (planType) {
        self.selectedPlanInfo(self.standardPlanInfo);
        parentViewModel.selectPlanTemplate("confirmPlanT");
    };

    self.goToPremiumPlan = function (planType) {
        self.selectedPlanInfo(self.premiumPlanInfo);
        parentViewModel.selectPlanTemplate("confirmPlanT");
    };

    self.goToComparePlans = function () {
        parentViewModel.selectPlanTemplate("comparePlansT");
    };

    self.goToPaymentInfo = function () {
        parentViewModel.selectPlanTemplate("paymentInfoT");
    };

    self.goToWelcomeToPlan = function () {
        parentViewModel.selectPlanTemplate("welcomeToPlanT");
    };

    self.isPending = ko.observable(false);

    self.createCustomer = function () {

        var token;
        self.stripe.createToken(self.cardNumberElement).then(function(result) {
            // Handle result.error or result.token
            token = result.token;
            if (token) {
                self.isPending(true);
                self.error(false);
                self.message(undefined);
                $.ajax(
                    {
                        url: '/create-subscription',
                        type: 'POST',
                        data: {
                            email: self.email(),
                            password: self.password(),
                            price: self.getSelectedPrice(),
                            cardToken: token.id
                        },
                        success: function (result) {
                            self.isPending(false);
                            if(result.success) {
                                if (!self.isLoggedIn()) {
                                    self.isLoggedIn(true);
                                    self.goToNextPage();
                                } else {
                                    self.goToWelcomeToPlan();
                                }
                                self.email(undefined);
                                self.password(undefined);
                                self.email(self.email);
                            } else {
                                self.error(true);
                                self.message(result.message);
                                parentViewModel.addMessage(result.message, "error");
                            }
                            parentViewModel.loadingMessage(null);
                        }
                    }
                );
            } else {
                self.cardErrorMessage(result.message);
            }
        });

    };

    self.registerAndContinue = function () {
        self.register(function () {
            parentViewModel.selectPlanTemplate('planConfirmedT');
        });
    };

    self.registerAndContinueWithFacebook = function () {
        self.facebookRegister(function () {
            parentViewModel.selectPlanTemplate('planConfirmedT');
        });
    };


}



